<div class="pwc-esp">
  <esp-loading></esp-loading>
  @if (showErrorMessage()) {
    <compass-callout
      type="critical"
      size="large"
      [hideIcon]="true"
      class="pwc-esp-message"
    >
      <compass-callout-content>
        {{ errorMessageText() }}
      </compass-callout-content>
    </compass-callout>
  }
  @if (showSuccessMessage()) {
    <compass-callout
      type="success"
      size="small"
      [hideIcon]="true"
      class="pwc-esp-message"
    >
      <compass-callout-content>
        Your changes have been saved successfully.
      </compass-callout-content>
    </compass-callout>
  }
  <router-outlet></router-outlet>
</div>
